/**
 * Article enum value sets — mirrored from the Odin `knowledge` schema (platform doc §3.1).
 *
 * The source of truth is the Schema Registry: an unknown value is rejected there with a 422.
 * Keeping the sets here (instead of inline in the contracts) means the BFF, the editor UI and the
 * contract validation cannot drift apart — and a schema change has exactly one place to land.
 */
/** `draft` → editing, `published` → visible, `archived` → out of navigation, `deleted` → soft-deleted. */
export const ARTICLE_STATUSES = ['draft', 'published', 'archived', 'deleted'];
/** App-level visibility gate: `public` articles may also appear on the public help surface. */
export const VISIBILITIES = ['internal', 'public'];
/** Where a revision came from — the editor, the BookStack import, or a restore. */
export const REVISION_SOURCES = ['editor', 'import', 'restore'];
/**
 * Bekerülhet-e a cikk a KERESŐINDEXBE (`chunks` tábla). **Ez biztonsági kapu, nem szűrő-kényelem.**
 *
 * MIÉRT VAN EGYETLEN SZABÁLY, KÜLÖN FÜGGVÉNYBEN — a 2026-08-14-i lelet tanulsága: az indexelésnek
 * KÉT független bemeneti útja van (a teljes újraépítés a `getIndexableArticles`-ből, az egy-cikkes
 * újraindexelés a szerkesztő mentéséből). A szabály eddig CSAK az egy-cikkes úton volt kiírva, a
 * teljes újraépítésen soha — mert amikor azt írták, a bemeneti halmaz még eleve csak publikált
 * cikket tartalmazott, így a szűrés „feleslegesnek" tűnt. Aztán a halmaz megváltozott (a belső
 * nézetek 2026-08-14 óta mutatják a vázlatokat), és kiderült, hogy az egyik úton nincs fal.
 * Egy megnevezett, közös predikátum megakadályozza, hogy a két út újra széttartson: ha a szabály
 * változik, EGY helyen változik, és mindkét kapu követi.
 *
 * MIÉRT FEHÉRLISTA (`=== 'published'`), nem tiltólista: fail-closed. Egy jövőbeli új státusz (pl.
 * `review`) így automatikusan KIMARAD az indexből, nem automatikusan bekerül — a hibázás iránya
 * „nem találja meg a kereső", nem „névtelen látogató megtalálja a befejezetlen tartalmat".
 *
 * MI TÖRTÉNIK, HA VALAKI KIVESZI: a `chunks` táblának NINCS `status` oszlopa, a publikus keresés
 * pedig KIZÁRÓLAG `visibility`-re szűr — a státusz az indexen BELÜL már nem véd. Egy effektíven
 * publikus vázlat tehát azonnal kereshetővé válna a bejelentkezés nélküli súgóban.
 * Lekötő tesztek: `apps/api/src/modules/knowledge/draft-visibility.spec.ts` (a bemeneti halmaz) és
 * `apps/api/src/modules/search/indexer.service.spec.ts` (mindkét indexelő út).
 */
export function isSearchIndexable(status) {
    return status === 'published';
}
//# sourceMappingURL=article.js.map